export enum TenantFlow {
    AGENT_CREATION = 'agentCreation',
    FUND_TRANSFER_ALLOWED = 'fundTransferAllowed',
    CARD_REQUEST_ACCESS_ALLOWED = 'cardRequestAccessAllowed',
    RESET_PASSCODE_FOR_CUSTOMER_ALLOWED = 'resetPasscodeForCustomerAllowed',
    AGENT_SEPARATE_MODULE = 'agentSeparateModule',
    PENDING_REQUESTS_MODULE = 'pendingRequestsModule',
    MAKER_CHECKER_LOAD_UNLOAD_FUNDS_MODULE = 'makerCheckerLoadUnloadFundsModule',
    REQUESTS_MODULE_ALLOWED = 'requestsModuleAllowed',
    EXCHANGE_RATE_ALLOWED = 'exchangeRateAllowed',
    ACTIVITY_LOGGER_MODULE = 'activityLoggerModule',
    CURRENCY_CONTROLS_MODULE = 'currencyControlsModule',
    BULK_CARD_ISSUANCE_MODULE = 'bulkCardIssuanceModule',
}
